module.exports = __webpack_public_path__ + "static/media/logo-unilabs.06fb54f3.svg";